<template>

  <iframe src="https://flk.npc.gov.cn/"
          width="100%" height="850">
  </iframe>
<!--  <div class="box">
    <div class="content">
      <el-tabs v-model="activeName" @tab-click="tabClick">
        &lt;!&ndash; 法律法规 &ndash;&gt;
        <el-tab-pane label="法律法规" name="first">
          <div style="display: flex;width: 100%;justify-content: space-between;">
            <el-button type="primary" @click="handAdd" size="small">新建</el-button>
            <Input
              search
              enter-button
              placeholder=" 请输入文件名/标签"
              v-model="fileNameOrTag"
              @on-search="getData(1)"
              style="width: 300px"
            />
            &lt;!&ndash;<Button type="primary" icon="ios-search" slot="append" @click="getDangerPlan(1)"></Button>&ndash;&gt;
          </div>
          <div style="margin-top: 20px;">
            <template>
              <el-table :data="tableData"
              :header-cell-style="{ fontWeight: 500, color: 'rgb(0,0,0,0.85)', background: '#fafafa' }"
              max-height="665"
              style="width: 100%">
                <el-table-column prop="proFileName" label="文件名" width="200">
                  <template slot-scope="{ row }">
                    <el-link
                      type="primary"
                      @click="linkDownload(row.filePath,row.fileName)"
                    >{{row.fileName}}</el-link>
                  </template>
                </el-table-column>
                <el-table-column prop="number" label="法规编号" width="150"></el-table-column>
                <el-table-column prop="type" label="分类" width="150">
                  <template slot-scope="{ row }">
                    <span v-if="row.type">{{ typeList[row.type - 1].name }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="constraintDegree" label="强制程度" width="150">
                  <template slot-scope="{ row }">
                    {{ row.constraintDegree === 1 ? '强制性' : '推荐性' }}
                  </template>
                </el-table-column>
                <el-table-column prop="issueOrganization" label="发布机构" width="150"></el-table-column>
                <el-table-column prop="issueTime" label="发布日期" width="150">
                  <template slot-scope="{ row }">
                    <span v-if="row.issueTime">{{ row.issueTime | timeFilter }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="activeTime" label="启用日期" width="150">
                  <template slot-scope="{ row }">
                    <span v-if="row.activeTime">{{ row.activeTime | timeFilter }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="abolishTime" label="废止日期" width="150">
                  <template slot-scope="{ row }">
                    <span v-if="row.abolishTime">{{ row.abolishTime | timeFilter }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="digest" label="摘要" width="150">
                  <template slot-scope="{ row }">
                    <el-popover
                      placement="left"
                      title=""
                      width="500"
                      trigger="hover"
                      :content="row.digest"
                      v-if="row.digest && row.digest !=='' && row.digest !== 'null' && row.digest !== undefined && row.digest.length > 35">
                      <span type="text" slot="reference" v-if="row.digest">{{ row.digest.substring(0,18) }}...</span>
                    </el-popover>
                    <span v-else>{{ row.digest }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="isUsing" label="现行法规">
                  <template slot-scope="{ row }">
                    {{ row.isUsing === 1 ? '是' : '否' }}
                  </template>
                </el-table-column>
                <el-table-column prop="identifyUser" label="辨识人" width="150"></el-table-column>
                <el-table-column prop="identifyTime" label="辨识日期" width="150">
                  <template slot-scope="{ row }">
                    <span v-if="row.identifyTime">{{ row.identifyTime | timeFilter }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="identify" label="辨识内容" width="150">
                  <template slot-scope="{ row }">
                    <el-popover
                      v-if="row.identify && row.identify !== undefined && row.identify.length > 18"
                      placement="left"
                      title=""
                      width="500"
                      trigger="hover"
                      :content="row.identify">
                      <span type="text" slot="reference" v-if="row.identify">{{ row.identify.substring(0,18) }}...</span>
                    </el-popover>
                    <span v-else>{{ row.identify }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="assessmentUser" label="复查人" width="150"></el-table-column>
                <el-table-column prop="assessmentTime" label="复查日期" width="150">
                  <template slot-scope="{ row }">
                    <span v-if="row.assessmentTime">{{ row.assessmentTime | timeFilter }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="assessment" label="复查内容" width="150">
                  <template slot-scope="{ row }">
                    <el-popover
                      v-if="row.assessment && row.assessment !== undefined && row.assessment.length > 18"
                      placement="left"
                      title=""
                      width="500"
                      trigger="hover"
                      :content="row.assessment">
                      <span type="text" slot="reference" v-if="row.assessment">{{ row.assessment.substring(0,18) }}...</span>
                    </el-popover>
                    <span v-else>{{ row.assessment }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="180" fixed="right">
                  <template slot-scope="{ row }">
                    <el-link type="primary" v-if="empId === row.identifyEmpId" @click="assessment(row, 0)">
                      辨识
                    </el-link>
                    <span class="line" v-if="empId === row.identifyEmpId">|</span>
                    <el-link type="primary" v-if="empId === row.assessmentEmpId" @click="assessment(row, 1)">
                      复查
                    </el-link>
                    <span class="line" v-if="empId === row.assessmentEmpId">|</span>
                    <el-link type="primary" @click="editBtn(row)">编辑</el-link>
                    <span class="line">|</span>
                    <el-link type="danger" @click="deleteData(row)" >删除</el-link>
                  </template>
                </el-table-column>
              </el-table>
              <div style="text-align: right; margin-top: 10px">
                <Page :total="total" :page-size="pageSize" :current="currentPage" @on-change="getData" />
              </div>
            </template>
          </div>
        </el-tab-pane>
        &lt;!&ndash; 基础库 &ndash;&gt;
        <el-tab-pane label="基础库" name="second">
          <div style="display: flex;width: 100%;justify-content: space-between;">
            <el-button type="primary" @click="baseAdd" size="small">新建</el-button>
            <Input
              search
              enter-button
              placeholder=" 请输入文件名/分类名"
              v-model="baseSearchContent"
              @on-search="getBaseData(1)"
              style="width: 300px"
            />
          </div>
          <div style="margin-top: 20px">
            <el-table
            :data="baseTableData"
            max-height="665"
            :header-cell-style="{ fontWeight: 500, color: 'rgb(0,0,0,0.85)', background: '#fafafa' }"
            style="width: 100%">
              <el-table-column prop="fileName" label="文件名">
                <template slot-scope="{ row }">
                  <el-link :underline="false" type="primary" @click="linkDownload(row.fileUrl,row.fileName)">{{ row.fileName }}</el-link>
                </template>
              </el-table-column>
              <el-table-column prop="type" label="文件分类" />
              <el-table-column prop="gmtCreate" label="上传时间" />
              <el-table-column prop="createUserName" label="上传人" />
              <el-table-column label="操作" width="100">
                <template slot-scope="{ row }">
                  <el-button type="text" style="color: #409EFF" @click="baseEditBtn(row)">编辑</el-button>
                  <el-button type="text" style="color: #F56C6C" @click="baseDeleteBtn(row)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div style="text-align: right; margin-top: 10px">
              <Page :total="baseTotal" :page-size="baseLimit" :current="baseCurPage" @on-change="baseCurPageChange" />
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>

    &lt;!&ndash; 辨识和评估的弹窗 &ndash;&gt;
    <el-dialog :title="diaType === 0 ? '辨识' : '复查'" :visible.sync="dialogTableVisible" width="30%">
      &lt;!&ndash; <mavon-editor :subfield="false" v-model="message.identify" :editable="diaType === 0"></mavon-editor> &ndash;&gt;
      <div>
        <div style="marginBottom: 10px">辨识结果</div>
         &lt;!&ndash; <el-input v-model="message.identify" type="textarea" :disabled="message.assessment ? true : false" style="background: white"></el-input> &ndash;&gt;
         <el-input v-model="message.identify" type="textarea" :disabled="resultStatus" style="background: white"></el-input>
      </div>
      <div v-if="resultStatus">
        <div style="margin-top:10px">复查结果</div>
        <el-input v-model="message.assessment" type="textarea" style="background: white"></el-input>
      </div>
      <div style="text-align: center;margin-top: 10px">
        <el-button type="primary" size="small" style="width: 50%" @click="submit">提交</el-button>
      </div>
    </el-dialog>

    &lt;!&ndash; 新建的弹框 &ndash;&gt;
    <el-dialog title="新建" :visible.sync="dialogVisible" width="35%" @close="closeDia">
      <el-row class="my_row">
        <el-col :span="4" class="input_label">
          <span style="color: red">*</span>
          文件分类：
        </el-col>
        <el-col :span="14" style="width: auto;">
          <el-input v-model="form.type" style="width: 360px" />
        </el-col>
      </el-row>
      <el-row class="my_row" style="margin-top: 30px">
        <el-col :span="4" class="input_label">
          <span style="color: red">*</span>
          上传文件：
        </el-col>
        <el-col :span="14">
          <el-upload
            class="upload-demo"
            drag
            action="/v1/lawsRegulations/uploadFile"
            :on-change="handleChange"
            :on-exceed="handleExceed"
            :limit="1"
            :file-list="fileList"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              将文件拖到此处，或
              <em>点击上传</em>
            </div>
          </el-upload>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="sureBaseAdd" size="small">确 定</el-button>
      </span>
    </el-dialog>
  </div>-->
</template>

<script>
import {
  lawsRegulationsUpdate,
  lawsRegulationsAdd,
  lawsBaseList,
  lawsBaseAdd,
  lawsBaseEdit,
  lawsBaseDelete
} from "@/api/processManager";
import { downLoadDocument } from '@/api/downLoad'
export default {
  data() {
    return {
      activeName: 'first',
      tableData: [], // 法律法规的表格
      fileNameOrTag: "",
      pageSize: 10,
      currentPage: 1,
      total: 0,
      pageTotal: 0,
      value: [],
      options: [],
      dialogTableVisible: false, //评估和辨识的弹框
      diaType: 0, // 判断是评估还是辨识
      // form: {
      //   assessment: '',
      //   content: ''
      // },
      resultStatus: false, // 评估的时候显示
      message: {
        assessment: "",
        identify: ""
      }, // 辨识评估的时候用
      typeList: [
        { id: 1, name: '法律法规' }, { id: 2, name: '行政法规' }, { id: 3, name: '地方性法规' },
        { id: 4, name: '部门规章' }, { id: 5, name: '标准与规范' }, { id: 6, name: '废止法律法规' },
        { id: 7, name: '其它' }
      ],
      empId: '', // 拿到自己的账户号和辨识评估人对比  控制按钮

      // 基础库的表格数据
      baseTableData: [],
      baseSearchContent: '',
      baseTotal: 0,
      baseCurPage: 1,
      baseLimit: 10,
      fileList: [],
      form: {},
      dialogVisible: false
    };
  },
  mounted: function() {
    this.empId = Number(localStorage.getItem('empId'))
    this.getData(1);
  },
  methods: {
    // 标签页切换
    tabClick(row) {
      if(row.name === 'first') {
        this.getData(1)
      }
      if(row.name === 'second') {
        this.getBaseData(1)
      }
    },
    // 法律法规获取列表
    getData: function(page) {
      this.currentPage = page;
      this.componentsMoudel.httpRequest
        .getRequestHander(
          this.componentsMoudel.getData("urls").getLegislation +
            "?limit=" +
            this.pageSize +
            "&curPage=" +
            page +
            "&search=" +
            this.fileNameOrTag
        )
        .openLoad()
        .startGet()
        .then(res => {
          let arr = res.body.data;
          // for (let i = 0; i < arr.length; i++) {
          //   // if (arr[i].filePath && arr[i].filePath !== 'null') {
          //   //   arr[i].filePath = JSON.parse(arr[i].filePath);
          //   // }
          //   try {
          //     arr[i].filePath = JSON.parse(arr[i].filePath);
          //   }
          //   catch {
          //     arr[i].filePath = null
          //   }
          // }
          this.tableData = arr;
          // console.log(this.tableData)
          this.total = res.body.cum;
          this.pageTotal = res.body.pageTotal;
        });
    },
    // 删除法律法规
    deleteData: function(row) {
      this.$confirm(`删除 《${row.filePath.fileName}》 , 是否继续?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.componentsMoudel.httpRequest
            .getRequestHander(
              this.componentsMoudel.getData("urls").deleteLegislation + row.id
            )
            .openLoad()
            .startPost()
            .then(res => {
              if (this.tableData.length <= 1 && this.currentPage > 1) {
                this.currentPage -= 1;
              }
              this.getData(this.currentPage);
              this.$message({
                showClose: true,
                message: "删除成功",
                type: "success"
              });
            });
        })
        .catch(() => {
          return;
        });
    },
    handAdd() {
      this.$router.push('AddLegislation')
    },

    // 编辑按钮
    editBtn(row) {
      let obj = { ...row }
      for(let i in obj) {
        if(obj[i] === undefined || obj[i] === null || obj[i] === 'null' || obj[i] === '') {
          delete obj[i]
        }
      }
      this.$router.push({
        name: 'AddLegislation',
        params: { key: {...obj} }
      })
    },

    // 辨识和评估
    assessment(val1, val2) {
      // console.log(val1)
      this.message = {};
      this.message = { ...val1 };
      if (val2 === 1) {
        if (!val1.identify) {
          this.$message.error("先辨识后才能复查");
          return;
        }
        this.resultStatus = true;
      } else {
        this.resultStatus = false;
      }
      this.dialogTableVisible = true;
      this.diaType = val2;
    },
    // 辨识和评估弹窗的提交按钮
    submit() {
      if (this.resultStatus === false) {
        // 辨识
        if (this.message.identify === "") {
          this.$message.error("辨识内容不能为空");
          return;
        } else {
          lawsRegulationsUpdate({
            content: this.message.identify,
            id: this.message.id,
            status: 1
          }).then(res => {
            this.dialogTableVisible = false;
            this.getData(this.currentPage);
          });
        }
      } else {
        // 评估
        if (this.form.result === "") {
          this.$message.error("评估内容不能为空");
          return;
        } else {
          lawsRegulationsUpdate({
            content: this.message.assessment,
            id: this.message.id,
            status: 2
          }).then(res => {
            this.dialogTableVisible = false;
            this.getData(this.currentPage);
          });
        }
      }
    },
    // 法律法规下载
    linkDownload(val1, val2) {
      downLoadDocument(val1, val2)
    },
    // 基础库的一些事件
    // 基础库新增
    baseAdd() {
      this.dialogVisible = true
    },
    // 获取基础库列表
    getBaseData(val) {
      if(val) {
        this.baseCurPage = val
      }
      lawsBaseList({ limit: this.baseLimit, curPage: this.baseCurPage, search: this.baseSearchContent, isPage: 1 }).then(res => {
        this.baseTableData = res.body.data
        this.baseTotal = res.body.cum
      })
    },
    // 翻页
    baseCurPageChange(val) {
      this.baseCurPage = val
      this.getBaseData()
    },
    handleChange(file, fileList) {
      this.fileList = fileList.slice(-3);
    },
    // 基础库保存
    sureBaseAdd: function() {
      if (this.fileList.length === 0) {
        this.$message.info("请上传文件");
        return;
      }
      this.form.fileUrl = this.fileList[0].response.data
      this.form.fileName = this.fileList[0].name
      if(this.form.id) {
        lawsBaseEdit(this.form).then(res => {
          this.$message.success("新增成功");
          this.getBaseData();
          this.dialogVisible = false
          this.form = {}
          this.fileList = []
        })
      } else {
        lawsBaseAdd(this.form).then(res => {
          this.$message.success("新增成功");
          this.getBaseData();
          this.dialogVisible = false
          this.form = {}
          this.fileList = []
        });
      }
    },
    // 关闭新增的弹窗
    closeDia() {
      this.fileList = [];
    },
    // 基础库编辑
    baseEditBtn(row) {
      this.dialogVisible = true
      this.form.id = row.id
      this.$set(this.form, 'type', row.type)
      this.fileList.push({
        name: row.fileName,
        response: { data: row.fileUrl }
      })
    },
    // 基础库删除
    baseDeleteBtn(row) {
      this.$confirm('此操作将删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        lawsBaseDelete(row.id).then(res => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
          this.getBaseData()
        })
      }).catch(() => {
        return        
      });
    },
    //限制文件上传个数
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 1 个文件`);
    },
  },
  created() {}
};
</script>

<style scoped>
.head {
  position: absolute;
  top: 0px;
  left: 250px;
  width: 80%;
  height: 60px;
}

.content {
  background-color: #ffffff;
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 10px;
  border: 1px solid #e9eef3;
}
.line {
  margin: 0 5px;
  color: rgb(240, 242, 245);
}
.box /deep/ .el-dialog__body {
  padding: 20px 30px 15px 30px;
}
</style>
